export const creatorImpactPath = '/creator-impact';
